import gql from 'graphql-tag'
export default gql`
  query ArtworkTypes ($value: Value) {
    ArtworkTypes (valueKey: "name", value: $value) {
      id
      name
      itemOrder
      }
    }
  `
